import {
  Component,
  OnInit
} from '@angular/core';
import {
  SkyDatepickerCalendarInnerComponent
} from './datepicker-calendar-inner.component';

import {
  SkyDatepickerDate
} from './datepicker-date';


export class SkyMonthPickerComponent implements OnInit {
  public title: string;
  public rows: Array<Array<SkyDatepickerDate>> = [];
  public datepicker: SkyDatepickerCalendarInnerComponent;
  public maxMode: string;

  public constructor(datepicker: SkyDatepickerCalendarInnerComponent) {
    this.datepicker = datepicker;
  }

  public ngOnInit(): void {

    this.datepicker.stepMonth = {
      years: 1
    };

    this.datepicker.setRefreshViewHandler(() => {
      this.refreshMonthView();
    }, 'month');

    this.datepicker.setCompareHandler(this.compareMonth, 'month');

    this.datepicker.refreshView();

    this.datepicker.setKeydownHandler((key: string, event: KeyboardEvent) => {
      this.keydownMonths(key, event);
    }, 'month');
  }

  private compareMonth(date1: Date, date2: Date): number {
    let d1 = new Date(date1.getFullYear(), date1.getMonth());
    let d2 = new Date(date2.getFullYear(), date2.getMonth());
    return d1.getTime() - d2.getTime();
  }

  private refreshMonthView(): void {
    let months: Array<SkyDatepickerDate> = new Array(12);
    let year: number = this.datepicker.activeDate.getFullYear();
    let date: Date;

    for (let i = 0; i < 12; i++) {
      date = new Date(year, i, 1);
      date = this.datepicker.fixTimeZone(date);
      months[i] =
        this.datepicker.createDateObject(
          date,
          this.datepicker.formatMonth,
          false,
          this.datepicker.datepickerId + '-' + i
        );
    }

    this.title =
      this.datepicker.dateFilter(this.datepicker.activeDate, this.datepicker.formatMonthTitle);
    this.rows = this.datepicker.createCalendarRows(months, this.datepicker.monthColLimit);
  }

  private keydownMonths(key: string, event: KeyboardEvent) {
    let date = this.datepicker.activeDate.getMonth();

    /* istanbul ignore else */
    /* sanity check */
    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - this.datepicker.monthColLimit;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + this.datepicker.monthColLimit;
    } else if (key === 'pageup' || key === 'pagedown') {
      let year = this.datepicker.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
      this.datepicker.activeDate.setFullYear(year);
    } else if (key === 'home') {
      date = 0;
    } else if (key === 'end') {
      date = 11;
    }
    this.datepicker.activeDate.setMonth(date);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-monthpicker',
  template: `<table *ngIf="datepicker.datepickerMode==='month'" role="grid">
  <thead>
    <tr>
      <th>
        <button
          type="button"
          class="sky-btn sky-btn-default sky-btn-sm sky-datepicker-btn-previous"
          (click)="datepicker.moveCalendar($event, -1)"
          tabindex="-1"
          >
          <i class="fa fa-chevron-left"></i>
        </button></th>
      <th [attr.colspan]="((datepicker.monthColLimit - 2) <= 0) ? 1 : datepicker.monthColLimit - 2">
        <button
          [id]="datepicker.datepickerId + '-title'"
          type="button"
          class="sky-btn sky-btn-default sky-btn-sm sky-datepicker-calendar-title"
          (click)="datepicker.toggleModeCalendar($event)"
          [disabled]="datepicker.datepickerMode === maxMode"
          [ngClass]="{'sky-btn-disabled': datepicker.datepickerMode === maxMode}"
          tabindex="-1"
          >
          <strong>{{title}}</strong>
        </button>
      </th>
      <th>
        <button
          type="button"
          class="sky-btn sky-btn-default sky-btn-sm sky-datepicker-btn-next"
          (click)="datepicker.moveCalendar($event, 1)"
          tabindex="-1"
          >
          <i class="fa fa-chevron-right"></i>
        </button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of rows">
      <td
        *ngFor="let date of row"
        class="text-center"
        role="gridcell"
        id="{{date.uid}}">
        <button
          type="button"
          class="sky-btn sky-btn-default sky-datepicker-btn-date"
          [ngClass]="{'sky-datepicker-btn-selected': date.selected, 'sky-btn-disabled': date.disabled, 'sky-btn-active': datepicker.isActive(date)}"
          [disabled]="date.disabled"
          (click)="datepicker.selectCalendar($event, date.date)"
          tabindex="-1"
          >
          <span [ngClass]="{'sky-datepicker-current': date.current}">{{date.label}}</span>
        </button>
      </td>
    </tr>
  </tbody>
</table>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyDatepickerCalendarInnerComponent, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
